import React from 'react'
import Login from "../components/login/Login"
const UserLogin = () => {
  return (
    <>
        <Login pageType="User"/>
    </>
  )
}

export default UserLogin